import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import selfImage from "../../assets/images/personal.png";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }

  const handleResumeClick = e => {
    e.preventDefault();

    if (greeting.resumeLink) {
      window.open(greeting.resumeLink, "_blank", "noopener,noreferrer");
    }

    const downloadUrl = greeting.resumeDownloadLink || greeting.resumeLink;
    if (downloadUrl) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = downloadUrl;
      document.body.appendChild(iframe);

      window.setTimeout(() => {
        document.body.removeChild(iframe);
      }, 30000);
    }
  };

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <div id="resume" className="empty-div"></div>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {greeting.resumeLink && (
                  <Button
                    text="Download my resume"
                    href={greeting.resumeLink}
                    newTab={false}
                    rel="noopener noreferrer"
                    onClick={handleResumeClick}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <div className="profile-image-wrapper">
              <img
                className="profile-image"
                alt="Profile"
                src={selfImage}
              ></img>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
